export const parts_page = {
  title: "Welcome {name}",
  /**
   * Page H1. Renders in PartsPage's MyPortal-style header. (Previously read
   * "Parts Inventory" — kept the same string key so other consumers don't
   * have to be re-wired, just relabelled.)
   */
  partsInventory: "Marketplace",
  page_subtitle:
    "Browse second-life turbine parts available for transfer through PAX.",
  sellAPart: "Sell a Part",
  subtitle: "Manage your parts inventory",
  description: "View and manage parts in your inventory",

  // Actions
  createPart: "Create Part",
  downloadParts: "Download Parts CSV",
  // Delete confirmation dialog
  deleteConfirmTitle: "Delete Part",
  deleteConfirmMessage:
    "Are you sure you want to delete this part? This action cannot be undone.",
  cancel: "Cancel",
  delete: "Delete",

  // Express interest dialog
  expressInterestDialogTitle: "Contact Us For More Info",

  logged_in_with_email: "Logged in with {email}",
  not_logged_in: "Not logged in",
};
